import { render, staticRenderFns } from "./SearchManual.vue?vue&type=template&id=481dea79&"
import script from "./SearchManual.vue?vue&type=script&lang=js&"
export * from "./SearchManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports